import { useEffect, useRef, useState } from "react";
import { getSaltOnSearch } from "../../PharmacyMedicineAdd/PharmacyMedicineService";

const MIN_SEARCH_LENGTH = 2;
const DEBOUNCE_MS = 350;

/**
 * Isolated hook for research-only medicine search in the Add Purchase screen.
 * Calls healthcare_providers/search/medicine and is completely separate from
 * the existing itemsMaster (pharma/masterItem) product search.
 */
export const usePurchaseMedicineResearchSearch = (searchQuery, isOTC) => {
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const requestIdRef = useRef(0);

	useEffect(() => {
		const q = (searchQuery || "").trim();

		if (!q || q.length < MIN_SEARCH_LENGTH) {
			requestIdRef.current += 1;
			setResults([]);
			setLoading(false);
			return;
		}

		const reqId = ++requestIdRef.current;

		const timer = window.setTimeout(async () => {
			setLoading(true);
			try {
				const body = { search: q, type: isOTC ? "otc" : "" };
				const res = await getSaltOnSearch(body);
				if (reqId !== requestIdRef.current) return;
				setResults(res.data?.data || []);
			} catch (err) {
				console.error("Purchase medicine research search error:", err);
				if (reqId === requestIdRef.current) setResults([]);
			} finally {
				if (reqId === requestIdRef.current) setLoading(false);
			}
		}, DEBOUNCE_MS);

		return () => window.clearTimeout(timer);
	}, [searchQuery, isOTC]);

	const isActive = (searchQuery || "").trim().length >= MIN_SEARCH_LENGTH;

	return { results, loading, isActive };
};
